// extracted by mini-css-extract-plugin
export var galleryContainer = "product-gallery-module--galleryContainer--UBFyR";
export var galleryControls = "product-gallery-module--galleryControls--OMUSj";